module.exports = __webpack_public_path__ + "img/employee-1-old.19b1c960.jpg";